import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {MatButtonModule} from '@angular/material/button';
import {MatDialogModule} from '@angular/material/dialog';
import {MatIconModule} from '@angular/material/icon';
import {TranslateModule} from '@ngx-translate/core';
import {WhatsNewDisplayComponent} from './whats-new-display/whats-new-display.component';
import {WhatsNewIndicatorComponent} from './whats-new-indicator/whats-new-indicator.component';
import {MatSpinnerOverlayModule} from '../viba/admin/content/mat-spinner-overlay/mat-spinner-overlay.module';

@NgModule({
  declarations: [WhatsNewDisplayComponent, WhatsNewIndicatorComponent],
  imports: [
    CommonModule,
    MatButtonModule,
    MatDialogModule,
    MatIconModule,
    TranslateModule,
    MatSpinnerOverlayModule,
  ],
  exports: [WhatsNewDisplayComponent, WhatsNewIndicatorComponent],
})
export class WhatsNewModule {}
